import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const COMMITMENTS = [
  {
    n: "01",
    h: "Doctor-led",
    p: "Care begins with a clinician order and ends with a report.",
  },
  {
    n: "02",
    h: "Clinician-independent",
    p: "No doctors or physiotherapists employed, in any market.",
  },
  {
    n: "03",
    h: "Commission-free",
    p: "Doctors are not paid for orders.",
  },
  {
    n: "04",
    h: "Verified and auditable",
    p: "Credentials checked; every order, session and outcome recorded.",
  },
];

export default function Slide10Commitments() {
  return (
    <div>
      <SlideTitle>
        Four commitments,{" "}
        <em className="italic text-teal-glow">built into the design</em>
      </SlideTitle>
      <div className="mt-14 grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
        {COMMITMENTS.map((c, i) => (
          <FadeUp
            key={c.n}
            delay={0.1 + i * 0.09}
            className="border-t border-white/15 pt-7"
          >
            <div className="font-display text-5xl font-light text-teal-glow">
              {c.n}
            </div>
            <h3 className="mt-6 text-xl font-semibold tracking-tight text-bone">
              {c.h}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-mint/65">{c.p}</p>
          </FadeUp>
        ))}
      </div>
      <SlideConclusion dark delay={0.45}>
        Ethical practice is the default path.
      </SlideConclusion>
    </div>
  );
}
